import { createContext } from 'react';

import type { DialogContextProps } from './DialogProvider.types';

export const DialogContext = createContext<DialogContextProps>({
  type: null,
  isOpen: false,
  onClose: () => undefined,
  onOpen: () => undefined,
  openDialog: undefined
});
